<template>
  <div class="page rule">
    <div class="rule-item">
      <div class="item-num">01</div>
      <div class="item-info">
        <div class="item-info-title">童币的定义？</div>
        <div class="item-info-desc">童币是一种虚拟积分奖励，学生可以在童程在线线上学习过程中可获得童币。</div>
      </div>
    </div>
    <div class="rule-item">
      <div class="item-num">02</div>
      <div class="item-info">
        <div class="item-info-title">如何获得童币？</div>
        <div class="item-info-desc">1.参加学员口碑活动</div>
        <div class="item-info-desc">2.学员完成其他活动任务</div>
        <div class="item-info-desc">以上具体活动可以向您班级的班主任了解详情</div>
      </div>
    </div>
    <div class="rule-item">
      <div class="item-num">03</div>
      <div class="item-info">
        <div class="item-info-title">童币有什么用？</div>
        <div class="item-info-desc">可以在童币商城兑换商品。</div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">

</script>

<style scoped lang="scss">
.rule {
  padding: 30px;
  padding-top: 11px;
  .rule-item {
    display: flex;
    .item-num {
      width: 42px;
      height: 42px;
      background: #F17000;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 20px;
      color: #FFFFFF;
      line-height: 28px;
      margin-right: 18px;
      border-radius: 50%;
      margin-top: 30px;
    }
    .item-info {
      flex: 1;
      .item-info-title {
        font-size: 30px;
        color: #333333;
        line-height: 42px;
        margin-top: 30px;
        margin-bottom: 12px;
      }
      .item-info-desc {
        font-size: 24px;
        color: #666666;
        line-height: 36px;
      }
    }
  }
}
</style>
